import { createAction } from 'redux-act';
import {
    types,
    ChatRead,
    JoinAllChatPayload,
    JoinChatPayload,
    NewContentType,
    Payload,
    TypingStatus,
    IMessagePayload,
    IMessage,
    IUserTyping,
    IDeleteRoomMessage,
    IReactToMessage,
    IUdateMessage,
    IDeleteRoomMessageSucess,
    IReactToMessageSuccess,
    IUpdateMessageSuccess,
    IGetRoomSuccess,
    IGetMyRoom,
} from './types';
import { IErrorType } from '../../constants/types';
import { Room } from '../../types/global/MessageNotification.types';

// --- User Actions ---
export const getAllUsers = createAction<any>(types.GET_ALL_USERS);
export const getAllUsersSuccess = createAction<any>(types.GET_ALL_USERS_SUCCESS);
export const getAllUsersFail = createAction<any>(types.GET_ALL_USERS_FAIL);

// --- Message Actions ---
export const getAllMessages = createAction<any>(types.GET_ALL_MESSAGES);
export const getAllMessagesSuccess = createAction<any>(types.GET_ALL_MESSAGES_SUCCESS);
export const getAllMessagesFail = createAction<any>(types.GET_ALL_MESSAGES_FAIL);

// --- Message Send/Delete ---
export const sendMessage = createAction<IMessagePayload>(types.SEND_MESSAGE);
export const sendMessageSuccess = createAction<IMessage>(types.SEND_MESSAGE_SUCCESS);
export const sendMessageFail = createAction<any>(types.SEND_MESSAGE_FAIL);

export const deleteMessage = createAction<IDeleteRoomMessage>(types.DELETE_MESSAGE);
export const deleteMessageSuccess = createAction<IDeleteRoomMessageSucess>(types.DELETE_MESSAGE_SUCCESS);
export const deleteMessageFail = createAction<IErrorType>(types.DELETE_MESSAGE_FAIL);

export const updateMessage = createAction<IUdateMessage>(types.UPDATE_MESSAGE);
export const updateMessageSuccess = createAction<IUpdateMessageSuccess>(types.UPDATE_MESSAGE_SUCCESS);
export const updateMessageFail = createAction<IErrorType>(types.UPDATE_MESSAGE_FAIL);

export const reactToMessage = createAction<IReactToMessage>(types.REACT_TO_MESSAGE);
export const reactToMessageSuccess = createAction<IReactToMessageSuccess>(types.REACT_TO_MESSAGE_SUCCESS);
export const reactToMessageFail = createAction<IErrorType>(types.REACT_TO_MESSAGE_FAIL);

// --- WebSocket Events ---
export const userTyping = createAction<IUserTyping>(types.USER_TYPING);
export const userStopTyping = createAction<IUserTyping>(types.USER_STOP_TYPING);

// --- Chat Actions ---
export const retrieveUserRooms = createAction<Payload>(types.RETRIEVE_USER_ROOMS);
export const joinChatRoom = createAction<JoinChatPayload>('JOIN_CHAT');
export const joinAllChatRooms = createAction<JoinAllChatPayload>(types.JOIN_ALL_CHAT_ROOMS);
export const typingStatusSocket = createAction<TypingStatus>(types.TYPING_STATUS);
export const userHasReadMessage = createAction<ChatRead>(types.USER_HAS_READ);

// --- New Content ---
export const newContent = createAction<NewContentType>(types.NEW_CONTENT);
export const setNewContentAvailable = createAction<NewContentType>(types.NEW_CONTENT_AVAILABLE);
export const resetNewContent = createAction(types.RESET_NEW_CONTENT);

// --- Rooms ---
export const getMyRooms = createAction<IGetMyRoom>(types.GET_MY_ROOMS);
export const getMyRoomsSuccess = createAction<IGetRoomSuccess>(types.GET_MY_ROOMS_SUCCESS);
export const getMyRoomsFail = createAction<IErrorType>(types.GET_MY_ROOMS_FAIL);

export const setRoomMessages = createAction<any>(types.SET_ROOM_MESSAGES);
export const setRoomMessagesSuccess = createAction<any>(types.SET_ROOM_MESSAGES_SUCCESS);
export const setRoomMessagesFail = createAction<any>(types.SET_ROOM_MESSAGES_FAIL);

export const updateUnreadMessageCount = createAction<any>(types.UPDATE_UNREAD_COUNT);

// Types
export type InitiateMessage = {
    /** Current logged in User */
    sender: string;
    /** User message is being sent to */
    receiver: string[];
    /** Optional Audition data */
    audition?: string;
    /** Optional Role data */
    role?: string;
    /** Message content */
    message_content: string;
    /** Checks if this message is from the modal */
    from_modal?: boolean;
};

interface ILeaveRoom {
    roomID: string;
    userID: string;
}

export const initiateMessageForRoom = createAction<InitiateMessage>(types.INITIATE_MESSAGE);
export const initiateMessageForRoomSuccess = createAction<Room>(types.INITIATE_MESSAGE_SUCCESS);
export const initiateMessageForRoomFail = createAction<IErrorType>(types.INITIATE_MESSAGE_FAIL);

export const getMessagesForSelectedRoom = createAction<JoinChatPayload>(types.GET_MESSAGES_FOR_SELECTED_ROOM);

export const leaveRoomAction = createAction<ILeaveRoom>(types.LEAVE_ROOM);

// --- Search Rooms ---
export const searchRooms = createAction<{
    searchTerm: string;
    page?: number;
    limit?: number;
    searchMessages?: boolean;
}>(types.SEARCH_ROOMS);
export const searchRoomsSuccess = createAction<any>(types.SEARCH_ROOMS_SUCCESS);
export const searchRoomsFail = createAction<any>(types.SEARCH_ROOMS_FAIL);

// Add type for file upload queue
export interface IFileUploadQueueItem {
    socketId: string;
    files: File[];
    messageId?: string;
    /** This should be the path where the media is stored */
    path: string;
    room: string;
}

// Add new action for queueing file uploads
export const queueFileUpload = createAction<IFileUploadQueueItem>(types.QUEUE_FILE_UPLOAD);

// Function signature that takes both parameters as a single object
export const uploadMessageFile = createAction<{
    messageId: string;
    fileItem: IFileUploadQueueItem;
    socketId: string;
    room: string;
}>(types.UPLOAD_MESSAGE_FILE);

// Function signature that takes both parameters as a single object
export const uploadMessageFileSuccess = createAction<{ messageId: string; fileUrls: string[]; socketId: string }>(
    types.UPLOAD_MESSAGE_FILE_SUCCESS,
);

// Function signature that takes both parameters as a single object
export const uploadMessageFileFail = createAction<{ messageId: string; error: any; socketId: string }>(
    types.UPLOAD_MESSAGE_FILE_FAIL,
);
